import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type PerformanceAudiencePageHeaderProps = {
  onExport?: () => void;
  syncLabel?: string;
};

export const PerformanceAudiencePageHeader: FC<PerformanceAudiencePageHeaderProps> = () => {
  const { t } = useTranslation('performanceAudience');

  return (
    <header className='grid gap-4'>
      <div className='flex flex-wrap items-center gap-3'>
        <div className='grid size-11 place-items-center rounded-full bg-ar-blue-soft text-ar-blue'>
          <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round' className='size-5' aria-hidden>
            <path d='M3 3v18h18' />
            <path d='M7 14v4M12 9v9M17 5v13' />
          </svg>
        </div>
        <div className='text-[22px] font-bold tracking-[-0.01em] text-ink-900'>{t('page.title')}</div>
        <p className='basis-full text-sm text-ink-500'>{t('page.subtitle')}</p>
      </div>
    </header>
  );
};
